import {
  MaterializedItemTaskDocument,
  MaterializedItemTaskQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useMaterializedTaskItem = (variables: MaterializedItemTaskQueryVariables) => {
  const { data, loading } = useQuery(MaterializedItemTaskDocument, { variables })

  const materializedItem = data?.processes.materializedItemsConnection.nodes?.[0]
  const materializedStep = materializedItem?.materializedStep

  const stepName = materializedStep?.name ?? '-'
  const mandatory = materializedItem?.item?.taskConfiguration?.mandatory ?? false
  const workflowOwnerId =
    materializedStep?.materializedProcess?.resourceRelationships?.at(0)?.resourceId

  return {
    workflowOwnerId,
    stepName,
    mandatory,
    loading,
  }
}
